// extracted by mini-css-extract-plugin
export default {"cellInput":"EditableInput_cellInput__Fd8Em"};